/**
 * CSV Pro Intelligence Architecture v1.0 — Foundation feature flags.
 *
 * All flags default to FALSE. The foundation phase is Dev-only and must not
 * change any existing Reviewer, Respondent, scoring or reporting behaviour.
 */

/** Reviewer Console "Assessment Profile" panel. Remains false until approved. */
export const REVIEWER_ASSESSMENT_PROFILE_ENABLED = false;

/**
 * Automatic manifest generation/freezing wired into the Respondent workflow.
 * Deliberately false — wiring is a separately gated step.
 */
export const AUTO_DNA_WIRING_ENABLED = false;

/** User-facing label for the internal "Assessment DNA" concept. */
export const ASSESSMENT_DNA_LABEL = "Assessment Manifest";

/** Placeholder for fields that were never historically captured. */
export const UNKNOWN_VALUE_LABEL = "Unknown / Not historically captured";
